import { render, staticRenderFns } from "./image_widget.vue?vue&type=template&id=d5203e94&scoped=true&lang=pug"
import script from "./image_widget.vue?vue&type=script&lang=js"
export * from "./image_widget.vue?vue&type=script&lang=js"
import style0 from "./image_widget.vue?vue&type=style&index=0&id=d5203e94&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5203e94",
  null
  
)

export default component.exports